module.exports = __webpack_public_path__ + "static/media/指尖文字识别.a0630016.png";